
import request from './.request'

export function listEnterpriseOfTown(t) {
  return request({
    url: `/static/dummy/entities/entity-${t}.json`,
    method: 'get'
  })
}

export function listEnterpriseGeoOfTown(t) {
  return request({
    url: `/static/dummy/entities/entity-${t}-geo.json`,
    method: 'get'
  })
}


export function listGreenhouseOfEnterprise(ecode) {
  return request({
    url: `/static/dummy/greenhouse/geo-house-${ecode}.geojson`,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/enterprise.js